import React, { useEffect } from "react";

import { useAppContext } from "../utils/context/app-context";

import { LoadingSpinner } from "../components/UiComponents";
import useDocumentTitle from "../components/useDocumentTitle";

function LoginAsTutor() {
	useDocumentTitle("Login As Tutor");
	let { api } = useAppContext();

	useEffect(() => {
		// Get jwt from url and set it, then redirect to dashboard after 2 seconds
		let url = new URL(window.location.href);
		let jwt = url.searchParams.get("jwt");
		if (jwt) {
			api.setToken(jwt);
			setTimeout(() => {
				window.location.href = "/";
			}, 2000);
		} else {
			alert("No JWT found");
		}
	}, []);

	return (
		<div>
			<div className="logging-in-as-tutor">
				<LoadingSpinner text="Logging in as Tutor..." />
			</div>
		</div>
	);
}

export default LoginAsTutor;
